<!-- biome-ignore-all lint/correctness/noVueVIfWithVFor: Init Biome -->

<script setup lang="ts">
import ComboButton from "../buttons/ComboButton.vue";

interface ComboInputTagProps {
    // biome-ignore lint/suspicious/noExplicitAny: Init Biome
    items: { label: string; value: any }[];
    icon?: string;
    placeholder?: string;
    size?: "xs" | "sm";
    variant?: "stroke" | "ghost";
}

withDefaults(defineProps<ComboInputTagProps>(), {
    size: "xs",
    variant: "stroke",
});
const emit = defineEmits<{
    (event: "click"): void;
    // biome-ignore lint/suspicious/noExplicitAny: Init Biome
    (event: "delete", value: any): void;
}>();

// biome-ignore lint/suspicious/noExplicitAny: Init Biome
const handleDelete = (item: { label: string; value: any }) => {
    emit("delete", item.value);
};
</script>
<template>
    <div class="ComboInputTag" @click="emit('click')">
        <i v-if="icon" :class="`ti ti-${icon}`"></i>
        <div class="placeholder" v-if="!items?.length && placeholder">{{ placeholder }}</div>
        <ComboButton
            v-if="items?.length"
            v-for="item of items"
            :size="size"
            :variant="variant"
            icon-right="x"
            @click.stop="handleDelete(item)"
            @right="handleDelete(item)"
            :key="item.value"
            :label="item.label"
        />
    </div>
</template>
<style lang="scss" scoped>
.ComboInputTag {
    display: flex;
    flex-wrap: wrap;
    min-height: 28px;
    min-width: 200px;
    max-width: 100%;
    gap: var(--spacing-md, 8px);
    border-radius: var(--radius-sm, 6px);
    padding: var(--spacing-xxs, 2px) var(--spacing-lg, 12px);
    align-items: center;
    cursor: pointer;
    .ti {
        color: var(--icon-soft-400, #9297aa);
    }
    .placeholder {
        color: var(--text-soft-400, #9297aa);
        font-weight: 500;
        @include font-size-13;
    }
    &:hover {
        background-color: var(--bg-weak-100, #eff2f5);
    }
    &:hover,
    &:focus,
    &:focus-visible {
        background-color: var(--bg-lightest-50, #f6f7f9);
        .ti {
            color: var(--icon-strong-900, #00061a);
        }
    }
}
</style>
